import clsx from 'clsx'
import { Check } from 'lucide-react'

interface Step {
  label: string
}

interface StepperProps {
  currentStep: number
  steps: Step[]
}

export const Stepper = ({ currentStep, steps }: StepperProps) => {
  const totalSteps = steps.length
  const centerOffsetPercent = 100 / (totalSteps * 2)
  const lineWidthPercent = 100 - centerOffsetPercent * 2

  const progressPercent =
    totalSteps > 1 && currentStep > 1
      ? ((currentStep - 1) / (totalSteps - 1)) * lineWidthPercent
      : 0

  return (
    <div className="relative flex items-center justify-between w-full max-w-4xl mx-auto">
      <div
        className="absolute top-4 h-1 bg-gray-300 z-0"
        style={{
          left: `${centerOffsetPercent}%`,
          width: `${lineWidthPercent}%`,
        }}
      />
      <div
        className="absolute top-4 h-1 bg-blue-500 z-10 transition-all duration-300"
        style={{
          left: `${centerOffsetPercent}%`,
          width: `${progressPercent}%`,
        }}
      />
      {steps.map((s, index) => {
        const stepNumber = index + 1
        const isActive = currentStep === stepNumber
        const isCompleted = currentStep > stepNumber

        return (
          <div
            key={index}
            className="relative z-20 flex flex-col items-center flex-1"
          >
            <div
              className={clsx(
                'w-8 h-8 mb-2 rounded-full flex items-center justify-center text-sm font-medium',
                {
                  'bg-blue-500 text-white': isActive || isCompleted,
                  'bg-gray-300 text-gray-700': !isActive && !isCompleted,
                },
              )}
            >
              {isCompleted ? <Check className="w-5 h-5" /> : stepNumber}
            </div>
            <div
              className={clsx('text-base font-medium', {
                'text-blue-500': isActive,
                'text-blue-600': !isActive && isCompleted,
                'text-gray-300': !isActive && !isCompleted,
              })}
            >
              {s.label}
            </div>
          </div>
        )
      })}
    </div>
  )
}
